import Vue from 'vue';
import Vuex from 'vuex';
// eslint-disable-next-line import/no-named-default
import { default as api, setGlobalRequestHeader } from '@virgodev/bazaar/functions/api';

import { save, load } from '../global_methods/store';

Vue.use(Vuex);

function setToken(userData) {
  let token = null;
  if (userData && userData.drf_token) {
    token = userData.drf_token;
  }
  setGlobalRequestHeader(
    'Authorization',
    token ? `Token ${token}` : undefined,
  );
}

const userData = load('userData', null);
if (userData) {
  setToken(userData);
}

export default new Vuex.Store({
  state: {
    categories: {},
    tags: load('tags', []),
    activeTags: [],
    latestFromRoute: { matched: [] },
    userGroups: load('userGroups', []),
    userData,
    log: [],
    feedItems: [],
    newFav: false,
    showAddButton: true,
  },
  mutations: {
    categories(state, value) {
      state.categories = value;
    },
    tags(state, value) {
      state.tags = value;
      save('tags', value);
    },
    activeTags(state, value) {
      state.activeTags = value;
    },
    latestFromRoute(state, value) {
      state.latestFromRoute = value;
    },
    userData(state, value) {
      state.userData = value;
      setToken(value);
      save('userData', value);
    },
    userGroups(state, value) {
      state.userGroups = value;
      save('userGroups', value);
    },
    feedItems(state, value) {
      state.feedItems = value;
    },
    newFav(state, value) {
      state.newFav = value;
    },
    showAddButton(state, value) {
      state.showAddButton = value;
    },
  },
  actions: {
    async fetchUserGroups(context) {
      if (context.state.userData && context.state.userData.drf_token) {
        const response = await api({
          url: 'groups/memberships/',
        });
        if (response.ok) {
          context.commit('userGroups', response.body);
        }
      }
    },
    async categories(context) {
      context.commit('categories', { loading: true });

      const responseData = await api({
        url: 'categories/',
      });

      if (responseData.status === 200) {
        context.commit('categories', { results: responseData.body });
      } else {
        context.commit('categories', { error: true });
      }
    },
    async fetchTags(context) {
      const responseData = await api({
        url: 'tags/',
      });

      if (responseData.status === 200) {
        context.commit('tags', { results: responseData.body });
      }
    },
    add_tag({ commit, state }, tag) {
      const newTags = state.activeTags;
      newTags.push(tag);
      commit('activeTags', newTags);
    },
    remove_tag({ commit, state }, index) {
      const newTags = state.activeTags;
      newTags.splice(index, 1);
      commit('activeTags', newTags);
    },
    set_new_fav(context, newFav) {
      context.commit('newFav', newFav);
    },
    set_show_add_button(context, newVal) {
      context.commit('showAddButton', newVal);
    },
    set_feed_items(context, data) {
      context.commit('feedItems', data);
    },
    push_feed_items(context, data) {
      context.commit('feedItems', context.state.feedItems.concat(data));
    },
    clear_feed_items(context) {
      context.commit('feedItems', false);
    },
    async update_post({ commit, state }, payload) {
      const newFeedItems = state.feedItems;

      const index = newFeedItems.findIndex(item => item.id === payload.id);

      const postId = newFeedItems[index].id;
      const responseData = await api({
        url: `posts/${postId}`,
        method: 'GET',
      });

      if (responseData.status === 200) {
        newFeedItems.splice(index, 1, responseData.body);
        commit('feedItems', newFeedItems);
      }
    },
    async delete_post({ commit, state }, payload) {
      const newFeedItems = state.feedItems;

      const index = newFeedItems.findIndex(item => item.id === payload.id);

      newFeedItems.splice(index, 1);

      commit('feedItems', newFeedItems);
    },
  },
  modules: {
  },
});
